import React, { useEffect, useState } from 'react';
import { signInWithRedirect } from '@aws-amplify/auth';
import { Hub } from '@aws-amplify/core';

const SignIn: React.FC = () => {
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Listen for auth events
    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      console.log('Auth event:', payload.event);
      // Check for any auth failure events
      if (payload.event.includes('failure')) {
        console.error('Auth failure:', payload);
        setError(typeof payload.message === 'string' ? payload.message : 'Authentication failed');
      }
    });

    // Redirect to Cognito hosted UI for sign in
    const initiateSignIn = async () => {
      try {
        console.log('Initiating sign in redirect...');
        await signInWithRedirect();
        console.log('If you see this, redirect did not happen immediately');
      } catch (error) {
        console.error('Error redirecting to sign in:', error);
        setError(error instanceof Error ? error.message : 'Failed to redirect to login');
      }
    };
    
    initiateSignIn();
    
    return () => unsubscribe();
  }, []);

  // Loading screen shown briefly before redirect
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="w-full max-w-md p-8 space-y-8 bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">Signing In</h1>
          {error ? (
            <div className="mt-4 p-3 bg-red-100 dark:bg-red-900 text-red-700 dark:text-red-300 rounded">
              {error}
            </div>
          ) : (
            <p className="text-base text-gray-600 dark:text-gray-400">
              Redirecting to authentication service...
            </p>
          )}
        </div>
        
        {!error && (
          <div className="flex justify-center mt-6">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SignIn;
